import { FR } from './france';

export const RE = FR;
